export const getCanvasSize = async ({
  blob,
  containerWidth,
  containerHeight
}: {
  blob: string;
  containerWidth?: number;
  containerHeight?: number;
}): Promise<{
  width: number;
  height: number;
  scale: number;
  imageWidth: number;
  imageHeight: number;
}> =>
  new window.Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => {
      let width = image.naturalWidth;
      let height = image.naturalHeight;
      let widthRatio = width / height;
      let heightRatio = height / width;
      let scale = 1;
      const windowWidth = containerWidth || window.innerWidth;
      const windowHeight = containerHeight || window.innerHeight;
      const heightOverflow = height - windowHeight;
      const widthOverflow = width - windowWidth;

      if (heightOverflow > 0 || widthOverflow > 0) {
        if (heightOverflow > widthOverflow) {
          scale = windowHeight / height;
          height = windowHeight;
          width = windowHeight * widthRatio;
        } else if (widthOverflow > heightOverflow) {
          scale = windowWidth / width;
          width = windowWidth;
          height = windowWidth * heightRatio;
        }
      }

      resolve({
        width,
        height,
        scale,
        imageWidth: image.naturalWidth,
        imageHeight: image.naturalHeight
      });
    };

    image.src = blob;
  });
